import { render } from "./order-popover.vue?vue&type=template&id=5fc95e26&ts=true"
import script from "./order-popover.vue?vue&type=script&lang=ts"
export * from "./order-popover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__